import { ADMIN_BASE_URL, BASE_URL } from "../api_const";


export const LAND_REGISTRATION_BASE_URL = BASE_URL + "/services/land-onboarding"
export const CREATE_LAND_REGISTRATION_REQUEST = LAND_REGISTRATION_BASE_URL + "/create"
export const LAND_REGISTRATION_DETAIL_BY_ID = LAND_REGISTRATION_BASE_URL 
export const ALL_LAND_REGISTRATION_REQUESTS = LAND_REGISTRATION_BASE_URL + "/all"
